var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"logo-grupa-zir",attrs:{"src":require("@/assets/grupa_zir.png"),"width":"200px"}})}
var staticRenderFns = []

export { render, staticRenderFns }